import axios from 'axios'
import EventBus from './event-bus'

const accessToken = localStorage.getItem('accessToken');
const base = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    Authorization: 'Bearer ' + accessToken
  }
});

const Api = {
  login(loginData) {
    return base.post('login', loginData);
  },
  forgotPassword(forgotPasswordData) {
    return base.post('forgotPassword', forgotPasswordData);
  },
  resetPassword(resetPasswordData) {
    return base.post('resetPassword', resetPasswordData);
  },
  isLogged() {
    if (localStorage.hasOwnProperty('accessToken')) {
      return this.checkUser().then(response => {
        let oldUser = JSON.parse(localStorage.getItem('user'));
        localStorage.setItem('user', JSON.stringify(response.data));
        if(oldUser != null && oldUser.person.client.status != response.data.person.client.status) {
          if(response.data.person.client.status == 'ACTIVE') {
            EventBus.$emit('CLIENT_STATUS_CHANGED');
          }
          else {
            window.location.reload();
          }
        }
        return true;
      }).catch(() => {
        localStorage.removeItem('accessToken');
        EventBus.$emit('IS_LOGGED', false);
        return false;
      });
    } else {
      return false;
    }
  },
  checkUser() {
    return base.get('checkUser', {
      params: {
        device_user_agent: navigator.userAgent,
        device_color_depth: screen.colorDepth,
        device_java_enabled: navigator.javaEnabled() ? 1 : 0,
        device_language: navigator.language,
        device_screen_height: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
        device_screen_width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
      }});
  },
  logoutOtherDevices() {
    return base.post('logout-other-devices');
  },
  checkVersion() {
    if(!localStorage.hasOwnProperty('version'))
      localStorage.setItem('version', process.env.VUE_APP_VERSION);

    let actualVersion = localStorage.getItem('version');

    return base.get('version').then(response => {
      if(actualVersion != response.data.version) {
        localStorage.setItem('version', response.data.version);
        localStorage.setItem('versionUpdated', true);
        window.location.reload(true);
      }
    }).catch(error => {
      console.log(error);
    });
  },
  getOnboardingStep() {
    let user = JSON.parse(localStorage.getItem('user'));
    return user.person.client.onboarding_step;
  },
  hasOnboarded() {
    return this.getOnboardingStep() == null;
  },
  isSuspended() {
    let user = JSON.parse(localStorage.getItem('user'));
    return user.person.client.status == 'SUSPENDED';
  },
  // checkTrial(route) {
  //   let user = JSON.parse(localStorage.getItem('user'));
  //   let client = user.person.client;
  //
  //   let testUntil = moment(client.test_until).endOf('day');
  //   let daysToEndTrial = Math.round(testUntil.diff(moment(), 'days', true));
  //
  //   if(client.subscription == null) {
  //     if(route.path != '/' && route.path != '/minha-assinatura' && route.path != '/configuracoes/configuracoes-gerais' && route.path != '/informacoes-pessoais' && route.path.indexOf('/configuracoes/agendas') == -1 && daysToEndTrial < -3) {
  //       return true;
  //     }
  //   } else {
  //     let subscription = client.subscription;
  //     let validUntil = moment(subscription.valid_until).endOf('day');
  //
  //     if(subscription.status != 'ACTIVE') {
  //       return true
  //     }
  //
  //     // if(subscription.status == 'ACTIVE' && va)
  //   }
  //
  //   return false;
  // },
  getAgendas(agendasData) {
    return base.get('agendas', { params: agendasData });
  },
  storeAgenda(agendaData) {
    return base.post('agendas', agendaData);
  },
  getAgendasData() {
    return base.get('agendas-data');
  },
  getAgendaConfigData(agendaId) {
    return base.get('agenda-config-data' + (agendaId != null ? ('/'+agendaId) : ''));
  },
  getAgenda(agendaId) {
    return base.get('agendas/'+agendaId);
  },
  updateAgenda(agendaId, agendaData) {
    return base.put('agendas/'+agendaId, agendaData);
  },
  deleteAgenda(agendaId) {
    return base.delete('agendas/'+agendaId);
  },
  getAppointments(appointmentData) {
    return base.get('appointments', { params: appointmentData });
  },
  storeAppointment(appointmentData) {
    return base.post('appointments', appointmentData);
  },
  getAppointment(appointmentId) {
    return base.get('appointments/'+appointmentId);
  },
  updateAppointment(appointmentId, appointmentData) {
    return base.put('appointments/'+appointmentId, appointmentData);
  },
  confirmAppointment(appointmentId) {
    return base.put('appointments/'+appointmentId+'/confirm');
  },
  cancelAppointment(appointmentId, cancelType, hide = true) {
    return base.put('appointments/'+appointmentId+'/cancel', { cancelType: cancelType, hide: hide });
  },
  hideAppointment(appointmentId) {
    return base.put('appointments/'+appointmentId+'/hide');
  },
  showupAppointment(appointmentId) {
    return base.put('appointments/'+appointmentId+'/showup');
  },
  missAppointment(appointmentId) {
    return base.put('appointments/'+appointmentId+'/miss');
  },
  getAppointmentAudit(appointmentId) {
    return base.get('appointments/'+appointmentId + '/audit');
  },
  startAttendanceAppointment(appointmentId) {
    return base.put('appointments/'+appointmentId+'/start-attendance');
  },
  checkTelehealthAttendance(personId, telehealthAttendanceId) {
    return base.put('people/'+personId+'/telehealth-attendance/'+telehealthAttendanceId+'/check');
  },
  startTelehealthAttendance(personId, telehealthAttendanceId) {
    return base.put('people/'+personId+'/telehealth-attendance/'+telehealthAttendanceId+'/start');
  },
  endTelehealthAttendance(personId, telehealthAttendanceId) {
    return base.put('people/'+personId+'/telehealth-attendance/'+telehealthAttendanceId+'/end');
  },
  getPeople(peopleData) {
    return base.get('people', { params: peopleData });
  },
  exportPeople(peopleData) {
    return base.get('people', { responseType: 'arraybuffer', params: peopleData });
  },
  storePerson(personData) {
    return base.post('people', personData);
  },
  getPersonFormData(personData) {
    return base.get('people-form-data', { params: personData });
  },
  getPerson(personId, personData) {
    return base.get('people/'+personId, { params: personData });
  },
  getPersonExtraData(personId) {
    return base.get('people/'+personId+'/extra-data');
  },
  updatePerson(personId, personData) {
    return base.put('people/'+personId, personData);
  },
  storeClientProfessionalProfile(professionalProfileData) {
    return base.post('client/professional-profile', professionalProfileData);
  },
  updateClientProfessionalProfile(professionalProfileId, professionalProfileData) {
    return base.put('client/professional-profile/'+professionalProfileId, professionalProfileData);
  },
  storeProfessionalProfile(personId, professionalProfileData) {
    return base.post('people/'+personId+'/professional-profile', professionalProfileData);
  },
  updateProfessionalProfile(personId, professionalProfileId, professionalProfileData) {
    return base.put('people/'+personId+'/professional-profile/'+professionalProfileId, professionalProfileData);
  },
  getTelehealthAppointmentData(personId, telehealthAttendanceId) {
    return base.get('people/'+personId+'/telehealth-appointment-data/'+telehealthAttendanceId);
  },
  getSpectateTelehealthAppointmentData(personId, appointmentId) {
    return base.get('people/'+personId+'/spectate-telehealth-appointment-data/'+appointmentId);
  },
  getPersonAppointments(personId) {
    return base.get('people/'+personId+'/appointments');
  },
  getPatientsInAttendance() {
    return base.get('patients-in-attendance');
  },
  getPersonAttendances(personId) {
    return base.get('people/'+personId+'/attendances');
  },
  startPersonAttendance(personId) {
    return base.post('people/'+personId+'/start-attendance');
  },
  endPersonAttendance(personId, attendanceData) {
    return base.put('people/'+personId+'/end-attendance', attendanceData);
  },
  uploadAttendanceTmpFile(fileData) {
    return base.put('attendances/upload-tmp-file', fileData);
  },
  initPrescription(personId) {
    return base.post('people/'+personId+'/attendance/init-prescription');
  },
  deletePrescription(prescriptionId) {
    return base.put('attendance/delete-prescription/' + prescriptionId);
  },
  storeAttendanceFormNote(attendanceId, noteData) {
    return base.post('attendance/'+attendanceId+'/form-note', noteData);
  },
  deletePerson(personId, deleteData) {
    return base.delete('people/'+personId, { params: deleteData });
  },
  unifyPerson(personId, unifyData) {
    return base.put('people/'+personId+'/unify', unifyData);
  },
  getPersonQuotes(personId) {
    return base.get('people/'+personId+'/quotes');
  },
  storePersonQuote(personId, quoteData) {
    return base.post('people/'+personId+'/quotes', quoteData);
  },
  updatePersonQuote(personId, quoteId, quoteData) {
    return base.put('people/'+personId+'/quotes/'+quoteId, quoteData);
  },
  deletePersonQuote(personId, quoteId) {
    return base.delete('people/'+personId+'/quotes/'+quoteId);
  },
  storePersonReminder(personId, reminderData) {
    return base.post('people/'+personId+'/reminders', reminderData);
  },
  updatePersonReminder(personId, reminderId, reminderData) {
    return base.put('people/'+personId+'/reminders/'+reminderId, reminderData);
  },
  deletePersonReminder(personId, reminderId) {
    return base.delete('people/'+personId+'/reminders/'+reminderId);
  },
  togglePersonReminder(personId, reminderId) {
    return base.post('people/'+personId+'/reminders/'+reminderId+'/toggle');
  },
  archivePersonReminder(personId, reminderId) {
    return base.post('people/'+personId+'/reminders/'+reminderId+'/archive');
  },
  getPersonTransactions(personId) {
    return base.get('people/'+personId+'/transactions');
  },
  getPersonTransactionSummary(personId) {
    return base.get('people/'+personId+'/transactions/summary');
  },
  getPersonAttendanceGuides(personId) {
    return base.get('people/'+personId+'/attendance-guides');
  },
  getSpecialities() {
    return base.get('specialities');
  },
  getHealthPlans(healthPlanData) {
    return base.get('health-plans', { params: healthPlanData });
  },
  getHealthPlan(healthPlanId) {
    return base.get('health-plans/'+healthPlanId);
  },
  storeHealthPlan(healthPlanData) {
    return base.post('health-plans', healthPlanData);
  },
  updateHealthPlan(healthPlanId, healthPlanData) {
    return base.put('health-plans/'+healthPlanId, healthPlanData);
  },
  deleteHealthPlan(healthPlanId) {
    return base.delete('health-plans/'+healthPlanId);
  },
  getDirectingSectors(directingSectorData) {
    return base.get('directing-sectors', { params: directingSectorData });
  },
  getDirectingSector(directingSectorId) {
    return base.get('directing-sectors/'+directingSectorId);
  },
  storeDirectingSector(directingSectorData) {
    return base.post('directing-sectors', directingSectorData);
  },
  updateDirectingSector(directingSectorId, directingSectorData) {
    return base.put('directing-sectors/'+directingSectorId, directingSectorData);
  },
  deleteDirectingSector(directingSectorId) {
    return base.delete('directing-sectors/'+directingSectorId);
  },
  createDirecting(directingSectorId, directingData) {
    return base.post('directing-sectors/'+directingSectorId+'/patient-directings', directingData);
  },
  getDirectingSectorData(directingSectorId) {
    return base.get('directing-sectors-data/'+directingSectorId);
  },
  callDirecting(directingSectorId, patientDirectingId) {
    return base.put('directing-sectors/'+directingSectorId+'/patient-directings/' + patientDirectingId + '/call');
  },
  endDirecting(directingSectorId, patientDirectingId) {
    return base.put('directing-sectors/'+directingSectorId+'/patient-directings/' + patientDirectingId + '/end');
  },
  getTussProcedures(tussProceduresData) {
    return base.get('tuss-procedures', { params: tussProceduresData });
  },
  getProcedures(procedureData) {
    return base.get('procedures', { params: procedureData });
  },
  getProcedure(procedureId) {
    return base.get('procedures/'+procedureId);
  },
  storeProcedure(procedureData) {
    return base.post('procedures', procedureData);
  },
  updateProcedure(procedureId, procedureData) {
    return base.put('procedures/'+procedureId, procedureData);
  },
  deleteProcedure(procedureId) {
    return base.delete('procedures/'+procedureId);
  },
  getAttendanceGuides(attendanceGuidesData) {
    return base.get('attendance-guides', { params: attendanceGuidesData });
  },
  getAttendanceGuide(attendanceGuideId) {
    return base.get('attendance-guides/'+attendanceGuideId);
  },
  storeAttendanceGuide(appointmentId, attendanceGuideData) {
    return base.post('appointments/'+appointmentId+'/attendance-guides', attendanceGuideData);
  },
  updateAttendanceGuide(appointmentId, attendanceGuideId, attendanceGuideData) {
    return base.put('appointments/'+appointmentId+'/attendance-guides/'+attendanceGuideId, attendanceGuideData);
  },
  deleteAttendanceGuide(appointmentId, attendanceGuideId) {
    return base.delete('appointments/'+appointmentId+'/attendance-guides/'+attendanceGuideId);
  },
  getAttendanceGuideInvoice(attendanceGuideInvoiceId) {
    return base.get('attendance-guides/invoices/'+attendanceGuideInvoiceId);
  },
  exportAttendanceGuidesData(exportData) {
    return base.get('attendance-guides/data/export-data', { responseType: 'arraybuffer', params: exportData });
  },
  getAppointmentTypes() {
    return base.get('appointment-types');
  },
  getClient(personData) {
    return base.get('client', { params: personData });
  },
  updateClient(clientData) {
    return base.put('client', clientData);
  },
  exportClientData(exportData) {
    return base.post('client/export-data', exportData);
  },
  requestSimulation() {
    return base.get('requestSimulation');
  },
  getHomeDashboardData() {
    return base.get('home-dashboard');
  },
  getDashboard(dashboardData) {
    return base.get('dashboard', { params: dashboardData });
  },
  exportDashboardData(exportData) {
    return base.get('dashboard/export-data', { responseType: 'arraybuffer', params: exportData });
  },
  getConfirmations(confirmationData) {
    return base.get('confirmations', { params: confirmationData });
  },
  getForms(formData) {
    return base.get('forms', { params: formData });
  },
  storeForm(formData) {
    return base.post('forms', formData);
  },
  getForm(formId) {
    return base.get('forms/'+formId);
  },
  updateForm(formId, formData) {
    return base.put('forms/'+formId, formData);
  },
  deleteForm(formId) {
    return base.delete('forms/'+formId);
  },
  tuss(tussData) {
    return base.get('tuss', { params: tussData });
  },
  cid10(cid10Data) {
    return base.get('cid10', { params: cid10Data });
  },
  getBankAccounts() {
    return base.get('bankAccounts');
  },
  storeBankAccount(bankAccountData) {
    return base.post('bankAccounts', bankAccountData);
  },
  getCategories(categoriesData) {
    return base.get('categories', { params: categoriesData });
  },
  storeCategory(categoryData) {
    return base.post('categories', categoryData);
  },
  getCashflow(cashflowData) {
    return base.get('transactions/cashflow', { params: cashflowData });
  },
  exportCashflowData(cashflowData) {
    return base.get('transactions/cashflow/export-data', { responseType: 'arraybuffer', params: cashflowData });
  },
  getTransactions(transactionData) {
    return base.get('transactions', { params: transactionData });
  },
  storeTransaction(transactionData) {
    return base.post('transactions', transactionData);
  },
  getTransaction(transactionId) {
    return base.get('transactions/'+transactionId);
  },
  updateTransaction(transactionId, transactionData) {
    return base.put('transactions/'+transactionId, transactionData);
  },
  dischargeTransaction(transactionId, transactionData) {
    return base.put('transactions/'+transactionId+'/discharge', transactionData);
  },
  deleteTransaction(transactionId, deleteType) {
    return base.put('transactions/'+transactionId+'/delete', { deleteType: deleteType });
  },
  deleteTransactionNf(transactionId, deleteType) {
    return base.put('transactions/'+transactionId+'/delete-nfse', { deleteType: deleteType });
  },
  getTransactionFormData(transactionData) {
    return base.get('transactions-form-data', { params: transactionData });
  },
  getPayers(payerData) {
    return base.get('payers', { params: payerData });
  },
  getPaidInvoices(paymentData) {
    return base.get('paid-invoices', { params: paymentData });
  },
  getSubscription() {
    return base.get('subscription');
  },
  makeSubscriptionPayment(paymentData) {
    return base.post('subscription/payment', paymentData);
  },
  changeSubscriptionPlan(planData) {
    return base.post('subscription/plan', planData);
  },
  cancelSubscriptionDowngrade() {
    return base.post('subscription/cancel-downgrade', {});
  },
  saveCreditCard(subscriptionData) {
    return base.post('subscription/save-credit-card', subscriptionData);
  },
  checkPixInvoice() {
    return base.get('invoices/check-pix-invoice');
  },
  deletePendingInvoice(invoiceId) {
    return base.put('invoices/pending/'+invoiceId+'/delete');
  },
  getInvoiceNfse(invoiceId) {
    return base.get('invoices/nfse/'+invoiceId, {responseType: 'arraybuffer'});
  },
  deleteCreditCard(subscriptionId) {
    return base.put('subscription/'+subscriptionId+'/delete-credit-card');
  },
  shareWithEmail(shareData) {
    return base.post('share-with-email', shareData);
  },
  getInvoices(invoicesData) {
    return base.get('invoices', { params: invoicesData });
  },
  getInvoice(invoiceId) {
    return base.get('invoices/'+invoiceId);
  },
  voidInvoice(invoiceId, voidData) {
    return base.delete('invoices/'+invoiceId+'/void', { params: voidData });
  },
  getInvoiceStatements(invoiceStatementFilterData) {
    return base.get('invoice-statements', { params: invoiceStatementFilterData });
  },
  getUnits(unitsData) {
    return base.get('units', { params: unitsData });
  },
  getUnitConfigData() {
    return base.get('units/config-data');
  },
  storeUnit(unitData) {
    return base.post('units', unitData);
  },
  getUnit(unitId) {
    return base.get('units/'+unitId);
  },
  updateUnit(unitId, unitData) {
    return base.put('units/'+unitId, unitData);
  },
  deleteUnit(unitId, deleteData) {
    return base.delete('units/'+unitId, { params: deleteData });
  },
  getSellers(sellersData) {
    return base.get('sellers', { params: sellersData });
  },
  getSellerConfigData() {
    return base.get('sellers/config-data');
  },
  storeSeller(sellerData) {
    return base.post('sellers', sellerData);
  },
  getSeller(sellerId) {
    return base.get('sellers/'+sellerId);
  },
  updateSeller(sellerId, sellerData) {
    return base.put('sellers/'+sellerId, sellerData);
  },
  deleteSeller(sellerId, deleteData) {
    return base.delete('sellers/'+sellerId, { params: deleteData });
  },
  getWhatsapps(whatsappsData) {
    return base.get('whatsapps', { params: whatsappsData });
  },
  getWhatsapp(whatsappId) {
    return base.get('whatsapps/'+whatsappId);
  },
  storeWhatsapp(whatsappData) {
    return base.post('whatsapps', whatsappData);
  },
  checkWhatsappStatus(whatsappId, whatsappData) {
    return base.get('whatsapps/'+whatsappId+'/status', { params: whatsappData });
  },
  updateWhatsapp(whatsappId, whatsappData) {
    return base.put('whatsapps/'+whatsappId, whatsappData);
  },
  deleteWhatsapp(whatsappId) {
    return base.delete('whatsapps/'+whatsappId);
  },
  disconnectWhatsapp(whatsappId) {
    return base.post('whatsapps/'+whatsappId+'/disconnect');
  },
  rebootWhatsapp(whatsappId) {
    return base.post('whatsapps/'+whatsappId+'/reboot');
  },
  // getPaymentSessionId() {
  //   return base.get('payments/get-session');
  // },
  // cancelPayment() {
  //   return base.post('payments/cancel-payment');
  // }
};

export default Api
